import React , {useEffect}from 'react';
import {Link} from 'react-router-dom';
import styled from '@emotion/styled';
// import { AndroidApp } from '../DownLoadMobileApp';
import { useTranslation } from 'react-i18next';
import MobileAppPhoto from '../../assets/images/Agios-Pavlos.jpg';
import { TextContainer, DownLoadText , GooglePlay } from '../DownLoadMobileApp';
import {ReactComponent as GooglePlaySVG} from '../../assets/svgs/google-play-svg.svg'
import Aos from "aos";
import 'aos/dist/aos.css';

const Container = styled.div`
    display:flex;
    margin-bottom: 180px;
    text-align:right;
    margin-top:80px;

    @media (max-width: 768px) {
    //   flex-direction:column;
    margin-top:20px;
    flex-direction: column-reverse;
      align-items:center;
      text-align:center;
      justify-content:center;
      margin-bottom: 80px;
    }

`;

const Title = styled.div`
   font-size: 40px;
   display:flex;
   color: #385963;
   font-weight: 600;
   margin-bottom: 20px;


     @media (max-width: 768px) {
    font-size: 25px;
    margin-top: 20px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
    margin-top: 20px;
  }
`;

const Description = styled.div`
   font-size: 20px;
   margin-bottom: 50px;
   color:#91abb3;
   
  @media (max-width: 768px) {
    font-size: 14px;
    margin: 0px 20px 40px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
    margin: 0px 10px 30px;
  }
`;

const Image = styled.img`
   height: 500px;
   width: 800px;
   border-radius: 15px;

   @media (max-width: 768px) {
     height: 300px;
     width: 400px;
   }

   @media (max-width: 480px) {
     height: 250px;
     width: 350px;
   }
`;

const AndroidApp = styled.div`
     border:  solid 2px  #385963;
     border-radius: 10px;
     width: 200px;
     padding: 5px;
     display:flex;
     background-color: white;
     align-items:center;
     place-self: flex-end;
    
     svg{
        height:50px;
        width:50px;
     }

      @media (max-width: 600px) {
       place-self:center;
       height: auto;
       width: ${({ selectedLanguage }) => (selectedLanguage === 'gr' ? '180px' : '170px')};
       padding:5px;
       svg{
        height:40px;
        width:40px;
       }
     }
`;

const SecondColumn = styled.div`
    display: flex;
    flex-direction: column;
    margin-right: 50px;
    align-items: right;
    justify-content: right;

    @media (max-width: 768px) {
     flex-direction:column;
     align-items:center;
     text-align:center;
     justify-content:center;
     margin-left:0;
     margin-right:0;
    }

  @media (max-width: 480px) {
      flex-direction:column;
      align-items:center;
      text-align:center;
      justify-content:center;
      margin-right:0;
  }
`;

const AgiosPavlosHome = () => {

    useEffect(()=>{
        Aos.init({duration:1000})
      },[]);  

   const { i18n } = useTranslation();
   const selectedLanguage = sessionStorage.getItem('selectedLanguage') || 'en';   

  
    return (
      <Container>
        
        <SecondColumn data-aos="zoom-in-down">
         <Title data-aos="zoom-in-down">{i18n.t('agiosPavlosTitle')}</Title>
         {/* <Description>{i18n.t('downloadTextDescr')}</Description> */}
         <AndroidApp 
      as="a" 
      href="https://play.google.com/store/apps/details?id=gr.auth.labgeo.apppavlos" // Replace with your actual app link
      target="_blank" 
      rel="noopener noreferrer"
      selectedLanguage={selectedLanguage}
      style={{ textDecoration: 'none' }} // Ensures no blue underline appears
    >
            <GooglePlaySVG/>
            <TextContainer>
                <DownLoadText> {i18n.t('downloadOn')}</DownLoadText>
                <GooglePlay>
                  {i18n.t('googlePlay')}</GooglePlay>
            </TextContainer>
        </AndroidApp>
        </SecondColumn>
        <Image src={MobileAppPhoto} data-aos="fade-right"/>
      </Container>
    )
}

export default AgiosPavlosHome
